import React from 'react';
import { useState } from 'react';

import BackDrop from '../Modal/Backdrop';
import styles from './Hamburger.module.css';

const HBNavItem = (props) => {
  return <li className={styles.HBNavigationItem}><a href={props.link}>{props.label}</a></li>
}

const HBNavButton = (props) => (
  <li className={styles.HBNavigationItem}><button onClick={props.callback}>{props.label}</button></li>
)

const Hamburger = (props) => {
  const [isOpen, setIsOpen] = useState( false );

  const drawerToggleHandler = () => {
    if (isOpen){
      document.getElementById('HBMenuDrawerToggle').checked = false;
    }
    setIsOpen( !isOpen );
  }

  const items = props.menu.map( (e) => (
    ('callback' in e ) 
    ? <HBNavButton key={Math.random()} label={e.label} callback={e.callback} />
    : <HBNavItem key={Math.random()} label={e.label} link={e.link} />
  )) 

  return <>
    <div className={styles.SideDrawer} onClick={drawerToggleHandler}>
      {isOpen && <BackDrop clicked={drawerToggleHandler} show={true} />}
      <input type="checkbox" className={styles.DrawerToggle} id="HBMenuDrawerToggle" onClick={drawerToggleHandler}/>
      <div className={styles.hamburger}><div></div></div>
      <div className={styles.SideDrawerMenu}>
        <ul className={styles.HBNavigationItems}>
          {items}
        </ul>
      </div>
    </div>
  </>
}

export default Hamburger;

/* 
<li className={styles.NavigationItem}><a href="#">HomeEX</a></li>
<li className={styles.NavigationItem}><a href="#">CSS</a></li>
<li className={styles.NavigationItem}><a href="#">ScriptC</a></li>
<li className={styles.NavigationItem}><a href="#">Com</a></li> 
*/